import { render, staticRenderFns } from "./PhrCodeTemplatePopup.vue?vue&type=template&id=3a1376dd&scoped=true&"
import script from "./PhrCodeTemplatePopup.vue?vue&type=script&lang=js&"
export * from "./PhrCodeTemplatePopup.vue?vue&type=script&lang=js&"
import style0 from "./PhrCodeTemplatePopup.vue?vue&type=style&index=0&id=3a1376dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1376dd",
  null
  
)

export default component.exports